var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product
    ? _c(
        "div",
        {
          class: [
            { "product-upsell--disabled": _vm.isProductDisabled },
            _vm.productUpsellClass(_vm.product),
            _vm.productUpsellCardType,
            {
              "position-relative":
                _vm.productUpsellCardType !== "product-upsell",
            },
          ],
          on: {
            click: function ($event) {
              return _vm.chooseProduct(_vm.product)
            },
          },
        },
        [
          _c(
            "div",
            {
              class: [
                "inner d-flex flex-column justify-content-between",
                { "product-upsell--highlighted": _vm.product.type === "PMP" },
                { selected: _vm.chosenProductToDisplay },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "product-upsell-main position-relative" },
                [
                  _c("h5", { staticClass: "title text-center mb-4 mt-3" }, [
                    _c("img", {
                      attrs: { src: _vm.icons[_vm.product.type], alt: "" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h4",
                    { staticClass: "title upsell-title text-capitalize" },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                  _vm._v(" "),
                  _c("product-details-simplified", {
                    class: {
                      "product-details--highlighted":
                        _vm.product.type === "PMP" && !_vm.usBookingMobile,
                    },
                    attrs: {
                      showTermsAndConditions: _vm.showTermsAndConditions,
                      product: _vm.product,
                      "upsell-card-type": _vm.productUpsellCardType,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.usBookingMobile
                ? _c("div", { staticClass: "product-upsell__footer" }, [
                    _c("span", { staticClass: "product-upsell__range" }, [
                      _c("img", { attrs: { src: _vm.icon, alt: "" } }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.labels.quoteHireLength) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-upsell__selection" }, [
                      _vm.product.total_price >= _vm.selectedProduct.total_price
                        ? _c("div", { staticClass: "total" }, [
                            _vm.showOriginalUpsellPrice(_vm.product)
                              ? _c(
                                  "strong",
                                  {
                                    staticClass: "original-amount-free-upgrade",
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.freeProductUpgradeOriginalDiffPerDay(
                                            _vm.selectedProduct,
                                            _vm.product,
                                            this.quoteHireDuration
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(
                              "\n                    + " +
                                _vm._s(
                                  _vm.freeProductUpgradeDisplayPrice(
                                    _vm.selectedProduct,
                                    _vm.product
                                  )
                                ) +
                                " "
                            ),
                            _c("small", [
                              _vm._v(_vm._s(_vm.labels.extraPerDay)),
                            ]),
                          ])
                        : _c("div", { staticClass: "total" }, [
                            _vm.showOriginalUpsellPrice(_vm.product)
                              ? _c(
                                  "strong",
                                  {
                                    staticClass: "original-amount-free-upgrade",
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.freeProductUpgradeOriginalDiffPerDay(
                                            _vm.selectedProduct,
                                            _vm.product,
                                            this.quoteHireDuration
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(
                              "\n                    − " +
                                _vm._s(
                                  _vm.freeProductUpgradeDisplayPrice(
                                    _vm.selectedProduct,
                                    _vm.product
                                  )
                                ) +
                                " "
                            ),
                            _c("small", [
                              _vm._v(_vm._s(_vm.labels.extraPerDay)),
                            ]),
                          ]),
                      _vm._v(" "),
                      !_vm.isProductDisabled
                        ? _c("span", { staticClass: "checkRound" }, [
                            _c("img", {
                              attrs: { "svg-inline": "", src: _vm.checkmark },
                            }),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _c(
                    "div",
                    { staticClass: "product-upsell-footer" },
                    [
                      [
                        _vm.upsellCardType !== "edit-booking" ||
                        (this.upsellCardType === "edit-booking" &&
                          !_vm.chosenProductToDisplay)
                          ? _c(
                              "button",
                              {
                                class: [
                                  "btn mb-2",
                                  {
                                    editing:
                                      _vm.upsellCardType === "edit-booking",
                                  },
                                  {
                                    "btn-link-outline":
                                      _vm.product.type !== "PMP",
                                  },
                                  { "btn-solid": _vm.product.type === "PMP" },
                                  "w-100 py-4",
                                ],
                                attrs: {
                                  disabled:
                                    (_vm.isProductDisabled &&
                                      _vm.upsellCardType === "edit-booking") ||
                                    (_vm.upsellCardType === "edit-booking" &&
                                      _vm.product.type ===
                                        _vm.selectedProduct.type),
                                  "data-dismiss": "modal",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("VehicleCard.upgrade")) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        this.upsellCardType === "edit-booking" &&
                        _vm.chosenProductToDisplay
                          ? _c(
                              "button",
                              {
                                class: [
                                  "btn mb-2",
                                  {
                                    editing:
                                      _vm.upsellCardType === "edit-booking",
                                  },
                                  {
                                    "btn-link-outline":
                                      _vm.product.type !== "PMP",
                                  },
                                  { "btn-solid": _vm.product.type === "PMP" },
                                  "w-100 py-4",
                                ],
                                attrs: {
                                  disabled:
                                    _vm.upsellCardType === "edit-booking",
                                  "data-dismiss": "modal",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("PriceCard.current_choice")) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.loadingPrices
                          ? _c("div", { staticClass: "total text-center" }, [
                              _c("strong", [_vm._v("…")]),
                            ])
                          : _c("div", [
                              _vm.product.should_show_difference
                                ? _c(
                                    "div",
                                    { staticClass: "total text-center" },
                                    [
                                      _vm.showOriginalUpsellPrice(_vm.product)
                                        ? _c("div", [
                                            _c(
                                              "b",
                                              {
                                                staticClass:
                                                  "original-amount-free-upgrade",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.freeProductUpgradeOriginalDiffPerDay(
                                                      _vm.selectedProduct,
                                                      _vm.product,
                                                      this.quoteHireDuration
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.product.difference >= 0
                                              ? _c("span", [_vm._v("+")])
                                              : _c("span", [_vm._v("−")]),
                                            _vm._v(
                                              "\n                             "
                                            ),
                                            _vm.showOriginalUpsellPrice(
                                              _vm.product
                                            )
                                              ? _c("strong", [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.freeProductUpgradeCurrentDiffPerDay(
                                                          _vm.selectedProduct,
                                                          _vm.product,
                                                          this.quoteHireDuration
                                                        )
                                                      ) +
                                                      "\n                            "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(_vm.labels.extraPerDay)
                                              ),
                                            ]),
                                          ])
                                        : _c("div", [
                                            _vm.product.difference >= 0
                                              ? _c("span", [_vm._v("+")])
                                              : _c("span", [_vm._v("−")]),
                                            _vm._v(
                                              "\n                             "
                                            ),
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.selectedPriceDiffBasePrice(
                                                    _vm.selectedProduct,
                                                    _vm.product,
                                                    this.quoteHireDuration
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(_vm.labels.extraPerDay)
                                              ),
                                            ]),
                                          ]),
                                    ]
                                  )
                                : _vm.product.total_price >=
                                  _vm.selectedProduct.total_price
                                ? _c(
                                    "div",
                                    { staticClass: "total text-center" },
                                    [
                                      _vm.showOriginalUpsellPrice(_vm.product)
                                        ? _c(
                                            "strong",
                                            {
                                              staticClass:
                                                "original-amount-free-upgrade",
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.freeProductUpgradeOriginalDiffPerDay(
                                                      _vm.selectedProduct,
                                                      _vm.product,
                                                      this.quoteHireDuration
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v("\n                        + "),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.freeProductUpgradeDisplayPrice(
                                              _vm.selectedProduct,
                                              _vm.product
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("small", [
                                        _vm._v(_vm._s(_vm.labels.extraPerDay)),
                                      ]),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "total text-center" },
                                    [
                                      _vm.showOriginalUpsellPrice(_vm.product)
                                        ? _c(
                                            "strong",
                                            {
                                              staticClass:
                                                "original-amount-free-upgrade",
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.freeProductUpgradeOriginalDiffPerDay(
                                                      _vm.selectedProduct,
                                                      _vm.product,
                                                      this.quoteHireDuration
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v("\n                        − "),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.freeProductUpgradeDisplayPrice(
                                              _vm.selectedProduct,
                                              _vm.product
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("small", [
                                        _vm._v(_vm._s(_vm.labels.extraPerDay)),
                                      ]),
                                    ]
                                  ),
                            ]),
                      ],
                    ],
                    2
                  ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }